import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Select, TextField, Typography, Grid, FormControlLabel, Button} from "@mui/material";

export const FormContainer = styled("div")`
    height: auto;
    width: 75%;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    bottom: 1em;
`;

export const Forms = styled("div")`
    color: black; 
    height: 100%;
`;